module.exports = __webpack_public_path__ + "static/media/DINNextRoundedLTPro-Regular.e4c6a9f8.otf";